// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function BuiltByDevelopers() {
  const bgImage =
    "https://yt3.ggpht.com/S28LRJUSUHsD4vFHVm6cP3QhKByFG9C7_MKyRAZUMPGzdOrKRD77MRAVSd_I-7wQ1Q8_Jfu4H_CtNg=s640-c-fcrop64=1,00000000ffffffff-rw-nd-v1";

  return (
    <MKBox
      display="flex"
      alignItems="center"
      borderRadius="xl"
      my={2}
      py={6}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.8),
            rgba(gradients.dark.state, 0.8)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Grid container item xs={12} lg={6} sx={{ ml: { xs: 0, lg: 6 } }}>
          <MKTypography variant="h4" color="warning" fontWeight="bold">
            Hi, I am CodeShow LapZ.
          </MKTypography>
          <MKTypography variant="h1" color="white" mb={1}>
            Full-Stack Software Dev:
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.8} mb={2}>
            Experienced with all stages of the development cycle for dynamic Java projects.
            Well-versed in numerous programming languages including Java, Python, PHP, JavaScript,
            My-Sql, Flutter, C#, React js, Express jx, Node js, Mongo db. Strong background in
            project management and customer relations.
          </MKTypography>
          <MKTypography
            component="a"
            href="https://github.com/SE-LAPS"
            target="_blank"
            rel="noreferrer"
            variant="body2"
            color="info"
            fontWeight="bold"
            sx={{
              display: "flex",
              alignItems: "center",
              "& .material-icons-round": {
                fontSize: "1.125rem",
                transform: `translateX(3px)`,
                transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                color: "yellow",
              },
              "&:hover .material-icons-round, &:focus .material-icons-round": {
                transform: `translateX(6px)`,
              },
            }}
          >
            More Details <Icon sx={{ fontWeight: "bold", color: "white" }}>arrow_forward</Icon>
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default BuiltByDevelopers;
